import PeopleIcon from '@mui/icons-material/People';
import { useTheme } from '@mui/material';

export const Community = ({ size = 'large' }) => {
  const theme = useTheme();

  return (
    <PeopleIcon fontSize={size} sx={{ color: theme.palette.tertiary.main }} />
  );
};
